import { Injectable, Injector, inject, linkedSignal, signal } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { ProfilePreferences } from '@scap/profile/models/profile.model'
import { PREFERENCIAS_DEFECTO } from '@scap/profile/utils/constants'
import { ProfileService } from './profile.service'
import { AlertErrorService, handleErrorsApi, handleResource, ToastService } from 'ng-components-tsi'
import { filter, firstValueFrom } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class ProfilePreferencesService {
  private readonly service = inject(ProfileService)
  private readonly alertError = inject(AlertErrorService)
  private readonly toast = inject(ToastService)
  private readonly injector = inject(Injector)

  rxProfile = handleResource(() => this.service.getProfile())
  _data = linkedSignal<ProfilePreferences>(() => this.processValue(this.rxProfile.value()))

  defaults = (): ProfilePreferences => {
    return {
      codper: PREFERENCIAS_DEFECTO.codper,
      nomper: PREFERENCIAS_DEFECTO.nomper,
      swautomar: PREFERENCIAS_DEFECTO.swautomar,
      initroute: PREFERENCIAS_DEFECTO.initroute,
      disabledPersonal: PREFERENCIAS_DEFECTO.disabledPersonal,
    }
  }

  processValue = (data:ProfilePreferences) => {
    if(!data) return null;
    return ({...data, disabledPersonal: !!data.codper})
  }

  async initRoute(): Promise<string> {
    if (this.rxProfile.isLoading()) {
      await firstValueFrom(
        toObservable(this.rxProfile.isLoading, { injector: this.injector }).pipe(filter(loading => !loading))
      )
    }
    const ruta = this._data()?.initroute
    return ruta && ruta !== '/' ? ruta : PREFERENCIAS_DEFECTO.initroute
  }

  async guardar(preferencias: ProfilePreferences) {

    this.service.save(preferencias).subscribe({
      next:() => {
        this.toast.success('Exito','Preferencias guardadas correctamente.')
        this._data.set(preferencias)
      },
      error:(err) => handleErrorsApi(err, this.alertError)
    })

  }
}
